import React from 'react';
import BasicPagination from 'src/common/refactoredComponents/paginator';
import {
    AccountPaginationContainer,
    Footer,
    MobileView,
    PaginationContainerMobile,
} from './InventoryFooter.styled';
import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import { TextBold } from 'src/common/components/filter/Filters.styled.jsx';
import {storeItemTableData} from 'src/pages/consignmentBilling/redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import { setProgressBarStatus } from 'src/pages/consignmentReturn/redux/actions';
import { useHistory } from 'react-router-dom';
import { getRoutePathWithParams } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

const InventoryFooter = ({
    inventoryDetails,
    inputVal,
    itemsVal,
    valid,
    totalResults,
    page,
    first,
    onPageChange,
    checked,
    searchItem,
    customStyle = {
        position: 'fixed',
        width: { standard: 'calc(100% - 5rem)', smallDevice: '100%' },
        padding: '10px',
        inPaddingVertical: '5px',
    },
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();

    const itemTableData = useSelector(
        (state) => state.consignmentBilling.itemTableData
    );

    const checkedItems = useSelector(
        (state) => state.InventoryReturnReducer.checkedItems
    );
    // let hasMagenicVendor = itemsVal.some( vendor => vendor['flag'] === 'true' )
    let errorMsg = checked?.some(
        (item) => item && (item.flag === true || item.used === '')
    );
    const count = checkedItems.reduce((counter, obj) => {
        if (obj && obj.isChecked === true) counter += 1;
        return counter;
    }, 0);
    const saveSelectedItems = () => {
        if (checkedItems && checkedItems?.length > 0) {
            // const itemArr = itemsVal.length > 0 ? itemsVal :filterCheckedItems;
            const items = checkedItems
                .filter((item) => item != undefined)
                .map((itemData) => ({
                    ...itemData,
                    lotSerial: [
                        {
                            Serial:
                                itemData.lotSerial ||
                                itemData.lotSerial?.[0].Serial,
                            Used: itemData.used,
                            isInvalidQtyMsg: null,
                        },
                    ],
                    uom: itemData?.uom ? itemData.uom : 'EA',
                }));
            let key = new Set(items.map((d) => d.uniqueKey));
            let newData = [
                ...items,
                ...itemTableData.filter((d) => !key.has(d.uniqueKey)),
            ];
            dispatch(storeItemTableData(newData));
            history.push(getRoutePathWithParams('/consignmentReturn'));
            dispatch(setProgressBarStatus('Account'));
        }
    };

    return (
        <>
            <AccountPaginationContainer>
                {inventoryDetails && inventoryDetails.length > 0 && (
                    <BasicPagination
                        totalRecords={
                            searchItem && searchItem.length > 0
                                ? inventoryDetails.length
                                : totalResults
                        }
                        recordsFetched={
                            inventoryDetails && inventoryDetails.length
                        }
                        pageNumber={page}
                        handleChange={(e) => onPageChange(e)}
                        first={first}
                        mobilePadding={'2% 2% 5% 2%'}
                        content={t('consignmentReturn.inventory.showingProducts')}
                        style={{
                            width: 'calc(100% - 5rem)',
                        }}
                        noMarginRight={true}
                    />
                )}
                <Footer>
                    <BottomNavigation
                        justifyContent="space-around"
                        moblieJustifyContent="space-evenly"
                        padding={customStyle.padding}
                        right={'0'}
                        position={customStyle.position}
                        zIndex={'0'}
                        width={customStyle.width}
                    >
                        <BottomNavigationButtonContainer>
                            <Button
                                id={'pages-consignmentReturn-inventoryFooter-addSelectedItems'}
                                show={true}
                                // primary={
                                //     checkedItems &&
                                //     checkedItems?.length > 0 &&
                                //     !errorMsg
                                //         ? true
                                //         : false
                                // }
                                variant={
                                    checkedItems && checkedItems?.length > 0 && !errorMsg
                                        ? ButtonStyles?.primary
                                        : ButtonStyles?.disabled
                                }
                                width={'220px'}
                                height={'38px'}
                                clicked={saveSelectedItems}
                                // disabled={
                                //     checkedItems &&
                                //         checkedItems?.length > 0 &&
                                //         !errorMsg
                                //         ? false
                                //         : true
                                // }
                            >
                                <TextBold color={'#FFFFFF'}>
                                    {t('consignmentReturn.inventory.addSelectedItems')} (
                                    {count != undefined ? count : '0'})
                                </TextBold>
                            </Button>
                        </BottomNavigationButtonContainer>
                    </BottomNavigation>
                </Footer>
            </AccountPaginationContainer>

            <MobileView>
                <PaginationContainerMobile padding={'15px'}>
                    {inventoryDetails && inventoryDetails.length > 0 && (
                        <BasicPagination
                            totalRecords={
                                searchItem && searchItem.length > 0
                                    ? inventoryDetails.length
                                    : totalResults
                            }
                            recordsFetched={
                                inventoryDetails && inventoryDetails.length
                            }
                            pageNumber={page}
                            handleChange={(e) => onPageChange(e)}
                            first={first}
                            mobilePadding={'2% 2% 2% 2%'}
                            content={t('consignmentReturn.inventory.showingProducts')}
                        />
                    )}
                </PaginationContainerMobile>
                <Footer>
                    <BottomNavigation
                        opacity={'1'}
                        border={'1px solid #1010EB'}
                        justifyContent={'right'}
                        moblieJustifyContent={'center'}
                        bottom={'0'}
                        left={'0'}
                        right={'0'}
                        position={'inherit !important'}
                    >
                        <Button
                            id="pages-consignmentReturn-inventoryFooter-addSelectedItems-mobile"
                            show={true}
                            //   primary={
                            //     checkedItems &&
                            //     checkedItems?.length > 0 &&
                            //     !errorMsg
                            //         ? true
                            //         : false
                            // }
                            variant={
                                checkedItems &&
                                    checkedItems?.length > 0 &&
                                    !errorMsg
                                    ? ButtonStyles?.primary
                                    : ButtonStyles?.disabled
                            }
                            top={'659px'}
                            left={'670px'}
                            width={'332px'}
                            height={'38px'}
                            margin={'0px 20px 15px 0px'}
                            clicked={saveSelectedItems}
                            // disabled={
                            //     checkedItems &&
                            //         checkedItems?.length > 0 &&
                            //         !errorMsg
                            //         ? false
                            //         : true
                            // }
                        >
                            <TextBold color={'#FFFFFF'}>
                                {t('consignmentReturn.inventory.addSelectedItems')} (
                                {count != undefined ? count : '0'})
                            </TextBold>
                        </Button>
                    </BottomNavigation>
                </Footer>
            </MobileView>
        </>
    );
};
export default InventoryFooter;

const BottomNavigationButtonContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 1096px;
    flex-direction: row;
    justify-content: ${(props) =>
        props.justifyContent ? props.justifyContent : 'flex-end'};

    @media only screen and (max-device-width: 1024px) and (min-device-width: 768px) and (orientation: landscape) {
        /* For ipad landscape layouts only */
        margin-right: 35px;
    }
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
        /* For portrait layouts only */
        justify-content: ${({ smallJustifyContent }) =>
        smallJustifyContent ? smallJustifyContent : 'center'};
        margin: ${(props) =>
        props.tabletPortraitMargin ? props.tabletPortraitMargin : ''};
    }

    //ipad Pro(10.5 inch) landscape
    @media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-max-device-pixel-ratio: 2) {
        margin-right: 35px;
    }

    ${media.mobileDevice`
        justify-content: space-evenly;
    `}
`;
